import React from 'react';
import { CSVLink } from 'react-csv';
 
class DownloadCsvs extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            csvData: []
        }
        this.onClickAsync = this.onClickAsync.bind(this);
    }

    onClickAsync(done){
        console.log('here')
        var tableId = this.props.tableId;
        var keys = this.props.keys;
        var oTable = document.getElementById(tableId);

        //gets rows of table
        var rowLength = oTable.rows.length;
        let data = [];
        //loops through rows    
        for (var i = 1; i < rowLength; i++) {

            //gets cells of current row  
            var oCells = oTable.rows.item(i).cells;
            // alert(oCells);
            
            data.push({
                [keys[0]]:oCells.item(0).innerHTML,
                [keys[1]]:oCells.item(1).innerHTML
                
            });
            
        }
        this.setState({csvData:data})
        done();
    }

    render(){
        return(
            <CSVLink 
                data={this.state.csvData} 
                headers={this.props.headers}
                className="btn btn-primary"
                filename={this.props.filename}
                asyncOnClick = {true}
                onClick = {(event,done) =>{
                    this.onClickAsync(done)
                    
                }}
        >
            Export Csv
            </CSVLink>
        )
    }
}

export default DownloadCsvs;


// WEBPACK FOOTER //
// ./src/Components/Sending-Out/downloadCsv_.js